import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';

const colorMap: Record<string, { bg: string; text: string; border: string; hoverBg: string }> = {
  accent: {
    bg: 'bg-accent-100',
    text: 'text-accent-800',
    border: 'border-accent-200',
    hoverBg: 'hover:bg-accent-200/70',
  },
  primary: {
    bg: 'bg-primary-100',
    text: 'text-primary-800',
    border: 'border-primary-200',
    hoverBg: 'hover:bg-primary-200/70',
  },
  secondary: {
    bg: 'bg-secondary-100',
    text: 'text-secondary-800',
    border: 'border-secondary-200',
    hoverBg: 'hover:bg-secondary-200/70',
  },
};

export default function CategoryCards() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
            探索饭岛爱的世界
          </h2>
          <p className="text-foreground-500 text-base max-w-xl mx-auto">
            从不同维度了解饭岛爱的人生、作品与深远影响
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {categories.map((cat) => {
            const colors = colorMap[cat.color] || colorMap.primary;
            return (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`${colors.bg} ${colors.border} border rounded-lg p-6 ${colors.hoverBg} transition-all cursor-pointer group flex flex-col items-center text-center`}
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-full ${colors.bg} mb-4`}>
                  <i className={`${cat.icon} text-xl ${colors.text}`}></i>
                </div>
                <h3 className={`font-heading text-base font-semibold ${colors.text} mb-2`}>
                  {cat.name}
                </h3>
                <p className="text-foreground-500 text-xs leading-relaxed">
                  {cat.description}
                </p>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}